// 产品目录
export const getBackCategory = (params: any) => {
  // const URL = `/marco/api/v1/category/list?level=${params.level}&thin=true`
  const queryString = new URLSearchParams({
    ...params,
    _t: `${Date.now()}`,
  }).toString();
  const URL = `/marco/api/v1/category/list?${queryString}`;
  return getApi(URL, { cache: "no-store" });
};

// 产品分组
export const getProductGroup = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/product/group?${queryString}`;
  return getApi(URL);
};

/**
 * 
 * @param params categoryId
 * @returns 产品分组新接口
 */
export const getProductGroupNew = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/groups/byCategory?${queryString}`;
  return getApi(URL);
};


// 产品属性查询
export const getAttributesProductGroup = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/product/groupAttributes?${queryString}`;
  return getApi(URL);
};

// 产品详情
export const getProductDetail = (params: any) => {
  const URL = `/marco/api/v1/product/detail?mcode=${params.mcode}`;
  return getApi(URL);
};

// 批量查询产品主图
export const getProductMainImages = (params: { goodsSkuCodes: string[] }) => {
  const queryString = new URLSearchParams();

  (params.goodsSkuCodes || []).forEach((goodsSkuCode) => {
    const skuCode = `${goodsSkuCode || ""}`.trim();
    if (skuCode) {
      queryString.append("goodsSkuCodes", skuCode);
    }
  });

  const URL = `/marco/api/v1/product/mainImages?${queryString.toString()}`;
  return getApi(URL);
};

// 产品搜索
// export const searchProd = (params: any) => {
//   const URL = `/marco/api/v1/product/search?searchStr=${params.searchStr}`;
//   return getApi(URL);
// };

// 产品应用明细
export const getProductAppItems = (params: any) => {
  const URL = `/marco/api/v1/product/applicationItem?mcode=${params.mcode}`;
  return getApi(URL);
};

// 产品组件
export const getProductParts = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/product/partsList?${queryString}`;
  return getApi(URL);
};

// 配件 (Parts) 应用列表 - 当前 mcode 对应的整机/单元 marco 编号集合，平铺显示
export const getProductPartsApp = (params: { mcode: string }) => {
  const queryString = new URLSearchParams(params as any).toString();
  const URL = `/marco/api/v1/product/partsApp?${queryString}`;
  return getApi(URL);
};

// 分类或分组产品搜索
export const getProductByCatGrp = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/product/listByBackCategoryOrGroup?${queryString}`;
  return getApi(URL);
};

// 产品分类全目录
export const getProductCatPath = (params: any) => {
  const URL = `/marco/api/v1/product/backCategory/path?id=${params.id}`;
  return getApi(URL);
};

// 产品应用信息
export const getProductAppInfo = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/product/appInfo?${queryString}`;
  return getApi(URL);
};

export const getProductAppProducts = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/product/applicationList?${queryString}`;
  return getApi(URL);
};

// 推荐位内容
export const getAd = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/product/advertisement?${queryString}`;
  return getApi(URL);
};

// 关键词
export const getSearchKeyword = () => {
  const URL = `/marco/api/v1/product/searchKeyword`;
  return getApi(URL);
};

/** 实时搜索
 * url /jeecg-boot/marco/api/v1/product/search
 * @param params page size searchStr
 * @returns 搜素列表
 */
export const search = (params: {
  page?: string;
  size?: string;
  searchStr: string;
}) => {
  const URL = `/marco/api/v1/product/search?searchStr=${params.searchStr}&page=${params.page}&size=${params.size}`;
  return getApi(URL);
};

// 根据应用查询model列表
export const getModelGroupList = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/product/modelGroupList?${queryString}`;
  return getApi(URL);
};

// 根据make查询分类
export const getCategoryByApp = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/product/getCategoryByApp?${queryString}`;
  return getApi(URL);
};

// 根据应用查询model列表
export const getModelList = (params: any) => {
  const queryString = new URLSearchParams(params).toString();
  const URL = `/marco/api/v1/product/modelList?${queryString}`;
  return getApi(URL);
};

// 获取分类页标签
export const listCategoryByParts = (data: any) => {
  let URL = "";
  if (data.name) {
    URL = `/marco/api/v1/product/listCategoryByParts?backCategoryId=${data.backCategoryId}&groupName=${data.name}`;
  } else {
    URL = `/marco/api/v1/product/listCategoryByParts?backCategoryId=${data.backCategoryId}`;
  }
  return getApi(URL);
};

// 记录搜索
export const searchRecord = (searchStr: string) => {
  const URL = `/marco/api/v1/product/searchRecord?searchStr=${searchStr}`;
  return postApi(URL);
};

// 全局搜索
export const serachCategory = (data: any) => {
  const baseURL = `/marco/api/v1/product/aggregation/search`;
  let URL = "";
  if (data) {
    URL = getApiUrl(baseURL, data);
  } else {
    URL = baseURL;
  }
  // const URL = `/marco/api/v1/product/aggregation/search?searchStr=${
  //   data.searchStr
  // }&size=${data.size}&page=${data.page}&izUnits=${
  //   data.izUnits || ""
  // }&prodCategoryBacks=${data.prodCategoryBacks || ""}&oeProducerNames=${
  //   data.oeProducerNames || ""
  // }&producerNames=${data.producerNames || ""}`;
  return getApi(URL);
};

/**
 * 获取文章列表
 * @returns
 */
export const articleList = (params?: {
  pageNo?: number;
  pageSize?: number;
  articleType?: number;
  column?: string;
  order?: "asc" | "desc";
}) => {
  const URL = params
    ? getApiUrl("/market/api/v1/articleList", params)
    : "/market/api/v1/articleList";
  return getApi(URL);
};

/**
 * /jeecg-boot/marco/api/v1/product/similar
 * @returns 获取相似产品
 */
export const similar = (data: { mcode: string; izUnit: string }) => {
  const URL = `/marco/api/v1/product/similar?izUnit=${data.izUnit}&mcode=${data.mcode}`;
  return getApi(URL);
};

/**
 * http://192.168.30.18:9090/jeecg-boot/market/api/v1/pageArticleDetail?pageNo=0&pageSize=2&articleType=4&articleName
 * articleType: 1公司介绍, 2新闻资讯, 3技术资料, 4帮助支持
 * @returns 获取新闻、help等列表数据
 */
export const getListData = (data: {
  pageNo: string;
  pageSize: string;
  articleType: string;
  articleName: string;
}) => {
  const URL = `/market/api/v1/pageArticleDetail?pageNo=${
    data.pageNo
  }&pageSize=${data.pageSize}&articleType=${data.articleType}&articleName=${
    data.articleName || ""
  }`;
  return getApi(URL);
};

/**
 * http://localhost:8081/jeecg-boot/marco/api/v1/getHomeDetail?homeName=Shop Now Starters
 * @return shopNow产品列表
 */
export const getShopNowData = (name: string) => {
  const params = new URLSearchParams({
    homeName: name,
  });
  // const encodedHomeName = encodeURIComponent(name);
  const URL = `/marco/api/v1/getHomeDetail?${params}`;
  return getApi(URL);
};
